import { Badge } from "@/components/ui/badge";

export type BillingStatus =
  | "Pending" | "Disputed" | "Billed" | "Paid" | "Overdue" | "Waived" | "Held" | "Partial";

const STATUS_CLASS: Record<BillingStatus, string> = {
  Pending:  "bg-yellow-100 text-yellow-700 border-yellow-200",
  Disputed: "bg-orange-100 text-orange-700 border-orange-200",
  Billed:   "bg-blue-100 text-blue-700 border-blue-200",
  Paid:     "bg-green-100 text-green-700 border-green-200",
  Overdue:  "bg-red-100 text-red-700 border-red-200",
  Waived:   "bg-zinc-100 text-zinc-600 border-zinc-200",
  Held:     "bg-amber-100 text-amber-700 border-amber-200",
  Partial:  "bg-blue-50 text-blue-600 border-blue-100",
};

export function BillingStatusBadge({ status }: { status: BillingStatus }) {
  return (
    <Badge variant="outline" className={`${STATUS_CLASS[status]} text-xs`}>{status}</Badge>
  );
}
